/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

/**
 * Reconnaissance « Avant la naissance » (code `N` du référentiel `ec_typrec`) :
 * l'enfant n'est pas encore né. Comme dans l'ETCV, sa date et son heure de
 * naissance ne se saisissent pas et ne s'affichent pas (AD-12845).
 */
const estReconnaissancePrenatale = (
  codeSousTypeActe: string | undefined | null,
) => _.trim(codeSousTypeActe ?? '') === 'N';

export default estReconnaissancePrenatale;
